import IconNodeJS from "../assets/images/icons/48-nodejs.svg";
import IconTypescript from "../assets/images/icons/48-typescript.svg";
import IconJavascript from "../assets/images/icons/48-javascript.svg";
import IconHTML from "../assets/images/icons/48-html.svg";
import IconCSS from "../assets/images/icons/48-css.svg";
import IconPHP from "../assets/images/icons/php-icon.svg";
import IconMongoDB from "../assets/images/icons/48-mongodb.svg";
import IconPostgreSQL from "../assets/images/icons/48-postgresql.svg";
import IconRedis from "../assets/images/icons/48-redis.svg";
import IconGCP from "../assets/images/icons/48-google-cloud.svg";
import IconBootstrap from "../assets/images/icons/48-bootstrap.svg";
import IconCodeIgniter from "../assets/images/icons/48-codeigniter.png";
import IconDocker from "../assets/images/icons/48-docker.svg";
import IconExpressjs from "../assets/images/icons/48-expressjs.svg";
import IconFirebase from "../assets/images/icons/48-firebase.svg";
import IconGit from "../assets/images/icons/48-git.svg";
import IconGraphql from "../assets/images/icons/48-graphql.svg";
import IconKubernetes from "../assets/images/icons/48-kubernetes.svg";
import IconNestjs from "../assets/images/icons/48-nestjs.svg";
import IconNetlify from "../assets/images/icons/48-netlify.png";
import IconSelenium from "../assets/images/icons/48-selenium.svg";
import IconPostman from "../assets/images/icons/48-postman.png";
import IconFastify from "../assets/images/icons/fastify.svg";
import IconJest from "../assets/images/icons/jest.svg";
import IconLaravel from "../assets/images/icons/laravel.svg";
import IconLumen from "../assets/images/icons/lumen.png";
import IconMui from "../assets/images/icons/mui.svg";
import IconPuppeteer from "../assets/images/icons/puppeteer.png";
import IconReact from "../assets/images/icons/react.svg";
import IconSequelize from "../assets/images/icons/sequelize.svg";
import IconStoplight from "../assets/images/icons/stoplight.svg";
import IconSocketIO from "../assets/images/icons/socketio.svg";
import IconStyledComponent from "../assets/images/icons/styled-components.png";
import IconTypeorm from "../assets/images/icons/typeorm.svg";

const skillAndTools = [
  {
    id: 0,
    name: "NodeJS",
    fillIcon: false,
    icon: IconNodeJS,
  },
  {
    id: 1,
    name: "Typescript",
    fillIcon: false,
    icon: IconTypescript,
  },
  {
    id: 2,
    name: "Javascript",
    fillIcon: false,
    icon: IconJavascript,
  },
  {
    id: 28,
    name: "React",
    fillIcon: false,
    icon: IconReact,
  },
  {
    id: 3,
    name: "HTML",
    fillIcon: false,
    icon: IconHTML,
  },
  {
    id: 4,
    name: "CSS",
    fillIcon: false,
    icon: IconCSS,
  },
  {
    id: 5,
    name: "PHP",
    fillIcon: false,
    icon: IconPHP,
  },
  {
    id: 6,
    name: "MongoDB",
    fillIcon: false,
    icon: IconMongoDB,
  },
  {
    id: 7,
    name: "PostgreSQL",
    fillIcon: false,
    icon: IconPostgreSQL,
  },
  {
    id: 8,
    name: "Redis",
    fillIcon: false,
    icon: IconRedis,
  },
  {
    id: 9,
    name: "Google Cloud Platform",
    fillIcon: false,
    icon: IconGCP,
  },
  {
    id: 10,
    name: "Bootstrap",
    fillIcon: false,
    icon: IconBootstrap,
  },
  {
    id: 11,
    name: "CodeIgniter",
    fillIcon: false,
    icon: IconCodeIgniter,
  },
  {
    id: 12,
    name: "Docker",
    fillIcon: false,
    icon: IconDocker,
  },
  {
    id: 13,
    name: "ExpressJS",
    fillIcon: true,
    icon: IconExpressjs,
  },
  {
    id: 14,
    name: "Firebase",
    fillIcon: false,
    icon: IconFirebase,
  },
  {
    id: 15,
    name: "Git",
    fillIcon: false,
    icon: IconGit,
  },
  {
    id: 16,
    name: "GraphQL",
    fillIcon: false,
    icon: IconGraphql,
  },
  {
    id: 17,
    name: "Kubernetes",
    fillIcon: false,
    icon: IconKubernetes,
  },
  {
    id: 18,
    name: "NestJS",
    fillIcon: false,
    icon: IconNestjs,
  },
  {
    id: 19,
    name: "Netlify",
    fillIcon: false,
    icon: IconNetlify,
  },
  {
    id: 20,
    name: "Selenium",
    fillIcon: false,
    icon: IconSelenium,
  },
  {
    id: 21,
    name: "Postman",
    fillIcon: false,
    icon: IconPostman,
  },
  {
    id: 22,
    name: "Fastify",
    fillIcon: true,
    icon: IconFastify,
  },
  {
    id: 23,
    name: "Jest",
    fillIcon: false,
    icon: IconJest,
  },
  {
    id: 24,
    name: "Laravel",
    fillIcon: false,
    icon: IconLaravel,
  },
  {
    id: 25,
    name: "Lumen",
    fillIcon: false,
    icon: IconLumen,
  },
  {
    id: 26,
    name: "Material UI",
    fillIcon: false,
    icon: IconMui,
  },
  {
    id: 27,
    name: "Puppeteer",
    fillIcon: false,
    icon: IconPuppeteer,
  },
  {
    id: 29,
    name: "Sequelize",
    fillIcon: false,
    icon: IconSequelize,
  },
  {
    id: 30,
    name: "Stoplight",
    fillIcon: false,
    icon: IconStoplight,
  },
  {
    id: 31,
    name: "Socket.IO",
    fillIcon: true,
    icon: IconSocketIO,
  },
  {
    id: 32,
    name: "Styled Component",
    fillIcon: false,
    icon: IconStyledComponent,
  },
  {
    id: 33,
    name: "Typeorm",
    fillIcon: false,
    icon: IconTypeorm,
  },
];

export default skillAndTools;
